import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/UserConext";

/**
 * PublicRoute component for pages like login
 * If user is already logged in, redirects to /home
 * If user is not logged in, renders the public page
 */
const PublicRoute = () => {
  const { user } = useUser();

  // Check if user is logged in (user.user exists and is not null)
  const isAuthenticated = user?.user !== null && user?.user !== undefined;

  // If authenticated, redirect to home (user shouldn't access login page)
  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  // If not authenticated, render the public page (login)
  return <Outlet />;
};

export default PublicRoute;
